/**
 * Zip utility to merge two arrays a, b of same length into a single array where each element is [a[i], b[i]]
 */
export function zipArrays(a, b) {
    if (a.length !== b.length) {
        throw new Error('Length of the two arrays to be zipped must be same');
    }
    return a.map(function (x, i) { return [x, b[i]]; });
}
